import useApi from "./Api";
import { useState } from "react";
import useCustomSnackbar from "../helper/useCustomSnackbar";

const usePut = () => {
  const [errorMsg, setErrorMsg] = useState("");
  const [response, setResponse] = useState(null);
  const Api = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const showSnackbar = useCustomSnackbar();
  const putData = async (
    url,
    data,
    isPut = true,
    showMessage = true,
    isFormData = false
  ) => {
    setIsLoading(true);
    try {
      const res = isPut
        ? await Api.put(url, data)
        : await Api.put(
            url,
            data,
            isFormData ? new Headers() : null,
            isFormData
          );

      if (res) {
        setResponse(res);
        if (showMessage) {
          showSnackbar("success", "Request successful", {
            vertical: "top",
            horizontal: "right",
          });
        }
        return res;
      } else {
        throw new Error("Empty response from API");
      }
    } catch (error) {
      console.error("API Error:", error);
      setErrorMsg(error.message);
      if (showMessage) {
        showSnackbar("error", error.message || "An error occurred", {
          vertical: "top",
          horizontal: "right",
        });
      }
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading, errorMsg, putData];
};

export default usePut;
